import { jsxs as f, jsx as e } from "react/jsx-runtime";
import { Popover as s, Separator as v } from "radix-ui";
import { c as b } from "../index-Cu0xwYjD.js";
import i from "react";
const x = "_content_4ywgb_1", y = "_scaleIn_4ywgb_1", P = "_item_4ywgb_12", g = "_active_4ywgb_26", h = "_separator_4ywgb_36", r = {
  content: x,
  scaleIn: y,
  item: P,
  active: g,
  separator: h
}, _ = i.createContext({
  close: () => {
  }
}), N = ({
  trigger: c,
  children: a,
  onOpenChange: t,
  defaultOpen: n = !1,
  align: l = "end",
  container: p
}) => {
  const [u, d] = i.useState(n), m = (o) => {
    d(o), t == null || t(o);
  };
  return /* @__PURE__ */ f(s.Root, { open: u, onOpenChange: m, children: [
    /* @__PURE__ */ e(s.Trigger, { asChild: !0, children: c }),
    /* @__PURE__ */ e(s.Portal, { container: p, children: /* @__PURE__ */ e(
      s.Content,
      {
        className: r.content,
        sideOffset: 5,
        align: l,
        onOpenAutoFocus: (o) => o.preventDefault(),
        children: /* @__PURE__ */ e(
          _.Provider,
          {
            value: { close: () => m(!1) },
            children: a
          }
        )
      }
    ) })
  ] });
}, S = ({
  children: c,
  closeMenuOnClick: a = !1,
  active: t = !1
}) => {
  const { close: n } = i.useContext(_), l = () => {
    a && n();
  };
  return /* @__PURE__ */ e(
    "div",
    {
      className: b(r.item, t && r.active),
      onClick: l,
      children: c
    }
  );
}, R = () => /* @__PURE__ */ e(v.Root, { className: r.separator, decorative: !0 });
export {
  N as PopoverMenu,
  S as PopoverMenuItem,
  R as PopoverMenuSeparator
};
